import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { FacetValue } from '@spartacus/core'
import { HttpUrlEncodingCodec } from '@angular/common/http'
import { MbConstants } from '../../shared/mb-constants'
import { distinctUntilChanged, shareReplay } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class SearchUtilsService {

  constants = MbConstants

  #isFacetsExpanded$ = new BehaviorSubject<boolean>(false)
  isFacetsExpanded$ = this.#isFacetsExpanded$.pipe(
    distinctUntilChanged(),
    shareReplay(1)
  )

  #isFacetsExpandedFromOutside$ = new BehaviorSubject<boolean>(false)
  isFacetsExpandedFromOutside$ = this.#isFacetsExpandedFromOutside$.pipe(
    distinctUntilChanged(),
    shareReplay(1)
  )

  #isCategoryPage$ = new BehaviorSubject<boolean>(false)
  isCategoryPage$ = this.#isCategoryPage$.pipe(
    distinctUntilChanged(),
    shareReplay(1)
  )

  toggleIsFacetExpanded (expand: boolean) {
    this.#isFacetsExpanded$.next(expand)
  }

  shrinkLinesForCategoryPage (shrink: boolean) {
    this.#isCategoryPage$.next(shrink)
  }

  toggleFacetsFromOutside (expand: boolean) {
    this.#isFacetsExpandedFromOutside$.next(expand)
  }

  createQueryForSearch (existingQuery: string, termToAdd: string) {
    if (termToAdd || termToAdd === '') {
      const queryWithoutHash: string = existingQuery?.split(this.constants.HASH_SYMBOL)?.[0]
      const encodedHash: string = existingQuery?.split(this.constants.HASH_SYMBOL)?.[1]
      const decodedHash: string = atob(encodedHash)
      const queryWithoutSearchTerm: string = queryWithoutHash?.split(this.constants.COLON_RELEVANCE)?.pop() || ''
      const queryWithNewSearchTerm: string = termToAdd + this.constants.COLON_RELEVANCE + queryWithoutSearchTerm
      const decodedHashWithoutSearchTerm: string = decodedHash?.split(this.constants.COLON_RELEVANCE)?.pop() || ''
      const decodedHashWithNewSearchTerm: string = termToAdd + this.constants.COLON_RELEVANCE + decodedHashWithoutSearchTerm
      const hashForNewQuery: string = btoa(decodedHashWithNewSearchTerm)
      return queryWithNewSearchTerm + this.constants.HASH_SYMBOL + hashForNewQuery
    }
    return existingQuery
  }

  getUrlAndHashOfFacetValue (facetValue: FacetValue): [prettyUrl: string, hashUrl: string] {
    const facetValueQuery: string | undefined = facetValue?.query?.query?.value
    const queryWithoutRelevance: string = facetValueQuery?.split(this.constants.RELEVANCE)?.pop() || ''
    const prettyUrlSegment: string = queryWithoutRelevance?.substring(0, queryWithoutRelevance?.indexOf(this.constants.HASH_SYMBOL))?.replace(/\+/g, ' ') || ''

    const urlDecodedPrettySegment: string = new HttpUrlEncodingCodec().decodeValue(prettyUrlSegment) || ''
    const hashUrlSegment: string = facetValueQuery?.split(this.constants.HASH_SYMBOL)?.pop()?.replace(/\+/g, ' ') || ''
    const urlDecodedHashUrlPart: string = new HttpUrlEncodingCodec().decodeValue(hashUrlSegment) || ''

    return [urlDecodedPrettySegment, urlDecodedHashUrlPart]
  }
}
